export default __webpack_public_path__ + "static/media/application.15ac7031.pdf";